import React, { Component } from "react";
import "../css/Editions.css";

import Oct22 from "../Images/coverpictures/oct22.jpeg";
import July22 from "../Images/coverpictures/july22.png";
import June22 from "../Images/coverpictures/june22.jpeg";
import April22 from "../Images/coverpictures/april22.jpeg";
import Feb22 from "../Images/coverpictures/feb22.png";
import Jan22 from "../Images/coverpictures/jan22.png";
import Winter21 from "../Images/coverpictures/winter21.jpeg";
import Oct21 from "../Images/coverpictures/oct21.png";
import Sept21 from "../Images/coverpictures/sept21.png";
import Aug21 from "../Images/coverpictures/aug21.png";
import July21 from "../Images/coverpictures/july21.png";
import June21 from "../Images/coverpictures/june21.png";

import { EditionSingle } from "./EditionCard";


class Editions extends Component {
  state = {
    editions: [
      {
        editionName: "June Edition '21",
        editionDate: "June 26, 2021",
        editionDescription: "This month we bring to you something new, a concept not very common when it comes to newsletters.We present to you Play- Sic the official monthly playlist from Innominate.",
        editionCover: June21,
        linkTo: "/editions/june21-edition",
      },
      {
        editionName: "July Edition '21",
        editionDate: "July 20, 2021",
        editionDescription: "This month we introduce a new section, 'Controversion'. From assessing the political situation of India to admiring the likes of Monika Seles, dive deep into this month's edition. Happy Reading!",
        editionCover: July21,
        linkTo: "/editions/july21-edition",
      },
      {
        editionName: "August Edition '21",
        editionDate: "August 26, 2021",
        editionDescription: "This month we, team Innominate have broadened our horizon and take a deeper dive to cover the best content, customized to make it as user-friendly so that you, can enjoy reading!",
        editionCover: Aug21,
        linkTo: "/editions/august21-edition",
      },
      {
        editionName: "September Edition '21",
        editionDate: "September 15, 2021",
        editionDescription: "This month we dive into the foreign relations between China and Afghanistan, review the 'Maddest Transfer Market' in the football world and much more.",
        editionCover: Sept21,
        linkTo: "/editions/september21-edition",
      },
      {
        editionName: "October Edition '21",
        editionDate: "October 31, 2021",
        editionDescription: "This month we review and analyze the development of affairs in the world of sports, take an opinion on the political polarization of India and like every month we present 'Taylor Swift' in our 'Play-Sic'.",
        editionCover: Oct21,
        linkTo: "/editions/october21-edition",
      },
      {
        editionName: "Winter Edition '21",
        editionDate: "December 28, 2021",
        editionDescription: "This festive season, we wish you a Merry Christmas & Happy New Year as with smiling faces we present to you, the much awaited and enthused - Winter Edition'21!",
        editionCover: Winter21,
        linkTo: "/editions/winter21-edition",
      },
      {
        editionName: "January Edition '22",
        editionDate: "January 25, 2022",
        editionDescription: "From Mahatma Gandhi's relevance to the Bootstrap Paradox, Innominate presents to you the January Edition '22 with the best content customized to your satisfaction.",
        editionCover: Jan22,
        linkTo: "/editions/january22-edition",
      },
      {
        editionName: "February Edition '22",
        editionDate: "February 12, 2022",
        editionDescription: "In the past month, the world has been subjected to a roller coaster ride when it comes to lifestyle and emotions. Starting from Biden's hot mic catch to the Ukraine invasion threat, we've got it all for you. Read Now!",
        editionCover: Feb22,
        linkTo: "/editions/february22-edition",
      },
      {
        editionName: "April Edition '22",
        editionDate: "April 04, 2022",
        editionDescription: "In light of the present war-torn situation, Innominate resorts to its roots as we base our April Edition'22 on 𝑝2, 'Protest & Peace'. From assessing the nuclear situation in Ukraine to our featured artuous. Happy Reading!",
        editionCover: April22,
        linkTo: "/editions/april22-edition",
      },
      {
        editionName: "June Edition '22",
        editionDate: "June 15, 2022",
        editionDescription: "We present to you the June Edition’22 based on the topic of US abortion laws. This month we take a venture out to explore the technicalities involved with abortion in the US.",
        editionCover: June22,
        linkTo: "/editions/june22-edition",
      },
      {
        editionName: "July Edition '22",
        editionDate: "July 30, 2022",
        editionDescription: "Here's Innominate completing a whole year of interesting editions with an exclusive Issue this month, 'Middle Eastern Nights'.",
        editionCover: July22,
        linkTo: "/editions/july22-edition",
      },
      {
        editionName: "October Edition '22",
        editionDate: "October 31, 2022",
        editionDescription: "It has indeed been quite some time since our last edition. So here’s bringing to you, the best of our works till date. This month, we explore the Gandhi Family on occasion...",
        editionCover: Oct22,
        linkTo: "/editions/oct22-edition",
      },
    ]
  }
  render() {
    return (
      <React.Fragment>
        <div className="container py-4" id="container">
          <div className="cards-editions">
            <div className="row mb-2">
              <EditionSingle editionName={this.state.editions[11].editionName} editionDate={this.state.editions[11].editionDate} editionDescription={this.state.editions[11].editionDescription} editionCover={this.state.editions[11].editionCover} linkTo={this.state.editions[11].linkTo} />
              <EditionSingle editionName={this.state.editions[10].editionName} editionDate={this.state.editions[10].editionDate} editionDescription={this.state.editions[10].editionDescription} editionCover={this.state.editions[10].editionCover} linkTo={this.state.editions[10].linkTo} />
            </div>
            <div className="row mb-2">
              <EditionSingle editionName={this.state.editions[9].editionName} editionDate={this.state.editions[9].editionDate} editionDescription={this.state.editions[9].editionDescription} editionCover={this.state.editions[9].editionCover} linkTo={this.state.editions[9].linkTo} />
              <EditionSingle editionName={this.state.editions[8].editionName} editionDate={this.state.editions[8].editionDate} editionDescription={this.state.editions[8].editionDescription} editionCover={this.state.editions[8].editionCover} linkTo={this.state.editions[8].linkTo} />
            </div>
            <div className="row mb-2">
              <EditionSingle editionName={this.state.editions[7].editionName} editionDate={this.state.editions[7].editionDate} editionDescription={this.state.editions[7].editionDescription} editionCover={this.state.editions[7].editionCover} linkTo={this.state.editions[7].linkTo} />
              <EditionSingle editionName={this.state.editions[6].editionName} editionDate={this.state.editions[6].editionDate} editionDescription={this.state.editions[6].editionDescription} editionCover={this.state.editions[6].editionCover} linkTo={this.state.editions[6].linkTo} />
            </div>
            <div className="row mb-2">
              <EditionSingle editionName={this.state.editions[5].editionName} editionDate={this.state.editions[5].editionDate} editionDescription={this.state.editions[5].editionDescription} editionCover={this.state.editions[5].editionCover} linkTo={this.state.editions[5].linkTo} />
              <EditionSingle editionName={this.state.editions[4].editionName} editionDate={this.state.editions[4].editionDate} editionDescription={this.state.editions[4].editionDescription} editionCover={this.state.editions[4].editionCover} linkTo={this.state.editions[4].linkTo} />
            </div>
            <div className="row mb-2">
              <EditionSingle editionName={this.state.editions[3].editionName} editionDate={this.state.editions[3].editionDate} editionDescription={this.state.editions[3].editionDescription} editionCover={this.state.editions[3].editionCover} linkTo={this.state.editions[3].linkTo} />
              <EditionSingle editionName={this.state.editions[2].editionName} editionDate={this.state.editions[2].editionDate} editionDescription={this.state.editions[2].editionDescription} editionCover={this.state.editions[2].editionCover} linkTo={this.state.editions[2].linkTo} />
            </div>
            <div className="row mb-2">
              <EditionSingle editionName={this.state.editions[1].editionName} editionDate={this.state.editions[1].editionDate} editionDescription={this.state.editions[1].editionDescription} editionCover={this.state.editions[1].editionCover} linkTo={this.state.editions[1].linkTo} />
              <EditionSingle editionName={this.state.editions[0].editionName} editionDate={this.state.editions[0].editionDate} editionDescription={this.state.editions[0].editionDescription} editionCover={this.state.editions[0].editionCover} linkTo={this.state.editions[0].linkTo} />
            </div>
            <div className="row mb-2" id="about-us-home"></div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Editions;